import React, { useState, useEffect, useMemo } from 'react';
import '../css/animate.css';
import '../css/barvy.css';
import '../css/style.css';
import { useLocation } from 'react-router-dom';

import logo1 from "../images/logo.png";
import logowhite from "../images/logo-white.png";
import { NavLink } from 'react-router-dom';
import { LuMenu } from "react-icons/lu";
import { AnimatePresence, motion } from 'framer-motion';

import { FaHome } from "react-icons/fa";
import { MdPedalBike } from "react-icons/md";
import { FaStore } from "react-icons/fa";
import { FaCogs } from "react-icons/fa";
import Nukeproof from "./Nukeproof-icon";
import { IoMdClose } from "react-icons/io";
import { getLocalizedText } from '../utils/textLocalization';
import { IoCloseSharp } from "react-icons/io5";
import { useEditry, getModelEntryData } from '@lazylabs-dev/editry-react';
import { isEditryConfigured } from '../utils/editryConfig';
import { getCurrentLanguage } from '../utils/languageSwitcher';
import { RiArrowDropDownLine } from "react-icons/ri";
import { RiArrowDropUpLine } from "react-icons/ri";
import { TbCornerDownRight } from "react-icons/tb";

function App({mode}) {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const [bikesOpen, setBikesOpen] = useState(false);
  const [bikesOpenMobile, setBikesOpenMobile] = useState(false);
  const [categories, setCategories] = useState([]);
  const { client } = useEditry();
  const editryReady = isEditryConfigured();
  const locale = useMemo(() => getCurrentLanguage(), []);
  const editryLanguage = useMemo(() => {
    const LOCALE_TO_CONTENT_LANGUAGE = {
      'cs-CZ': 'cs',
      'sk-SK': 'sk',
      'pl-PL': 'pl',
      'hu-HU': 'hu',
    };
    return LOCALE_TO_CONTENT_LANGUAGE[locale] || 'cs';
  }, [locale]);

  // Get localized text
  const homeText = getLocalizedText('nav.home');
  const bikesText = getLocalizedText('nav.bikes');
  const closeText = getLocalizedText('nav.close');
  const aboutText = getLocalizedText('nav.about');
  const dealersText = getLocalizedText('nav.dealers');
  const configuratorText = getLocalizedText('nav.configurator');

  // Load bikes from Editry
  useEffect(() => {
    let cancelled = false;

    const loadCategories = async () => {
      if (!editryReady) {
        setCategories([]);
        return;
      }

      try {
        const modelsResponse = await client.getPublicModels();
        const pick4Model = modelsResponse?.data?.find((model) => model.slug === 'pick-4');

        if (!pick4Model) {
          if (!cancelled) {
            setCategories([]);
          }
          return;
        }

        let itemsResponse = await client.getPublicModelItems(pick4Model.id, editryLanguage);
        let items = itemsResponse?.data || [];

        if (!items.length) {
          itemsResponse = await client.getPublicModelItems(pick4Model.id);
          items = itemsResponse?.data || [];
        }

        const parsed = items
          .map((item) => {
            const fields = getModelEntryData(item);
            return {
              cesta: fields.cesta || item.slug || '',
              nazev: fields.nazev || item.name || '',
            };
          })
          .filter((item) => item.cesta && item.nazev);

        if (!cancelled) {
          setCategories(parsed);
        }
      } catch (error) {
        if (!cancelled) {
          setCategories([]);
        }
      }
    };

    loadCategories();

    return () => {
      cancelled = true;
    };
  }, [client, editryLanguage, editryReady]);

  const mobile = () => {
    setOpen(!open);
  };

  const openBikes = () => {
    setBikesOpen(true);
  }

  return (
    <div>
      <header id="banner" className={`scrollto clearfix`} data-enllax-ratio="0.5">
        <div id="header" className={`nav-collapse ${location.pathname === "/konfigurator"  && "white-stripe-topbar"}`}>
          <div className={`row clearfix`}>
            <div className="header-remake-background">
              <div id="logo">
                <NavLink to="/">
                  <img src={mode === "light" ? logo1 : location.pathname === "/konfigurator" ? logo1 : logowhite} id="banner-logo" alt="Nukeproof logo" />
                </NavLink>
              </div>

              <nav id="nav-main" className="barlow-semibold nav-big shadow">
                <ul>
                  <li>
                    <NavLink className={location.pathname === "/konfigurator" ? "pointer" : "pointer white-text"} to="/">{homeText}</NavLink>
                  </li>
                  <li>
                    <NavLink className={location.pathname === "/konfigurator" ? "pointer" : "pointer white-text"} onClick={openBikes}>{bikesText}</NavLink>
                  </li>
                  <li>
                    <NavLink className={location.pathname === "/konfigurator" ? "pointer" : "pointer white-text"} to="/o-nukeproof">{aboutText}</NavLink>
                  </li>
                  <li>
                    <NavLink className={location.pathname === "/konfigurator" ? "pointer" : "pointer white-text"} to="/prodejci">{dealersText}</NavLink>
                  </li>
                  <li>
                    <NavLink className={location.pathname === "/konfigurator" ? "pointer konfigurator-topbar" : "pointer white-text konfigurator-topbar"} to="/konfigurator">{configuratorText}</NavLink>
                  </li>
                </ul>
              </nav>

              <AnimatePresence>
              {bikesOpen && (
                <motion.div className="bikes-dropdown-container" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }} onClick={() => setBikesOpen(false)}>
                  <motion.div className="bikes-dropdown" initial={{ x: -20, opacity: 0 }} animate={{ x: 0, opacity: 1 }} exit={{ x: -20, opacity: 0 }} transition={{ duration: 0.3 }} onClick={(e) => e.stopPropagation()}>
                    <button onClick={() => setBikesOpen(false)}><IoCloseSharp /> {closeText}</button>

                    <div>
                      <h3>{bikesText}</h3>
                      {categories.length > 0 ? (
                        categories.map((bike, index) => (
                          <NavLink
                            key={index}
                            to={`/kola/${bike.cesta}`}
                            onClick={() => setBikesOpen(false)}
                          >
                            {bike.nazev}
                          </NavLink>
                        ))
                      ) : (
                        <p>Načítání...</p>
                      )}
                    </div>

                    {/*<img src={biker} alt="Biker" className="bikes-dropdown-image" />*/}
                  </motion.div>
                </motion.div>
              )}
              </AnimatePresence>

              {open ? <>
              <button onClick={mobile} className="mobileMenu-open" id="mobile-button"><IoMdClose /></button>
              </>:<>
              <button onClick={mobile} className={location.pathname === "/konfigurator" ? "mobileMenu white-text" : "mobileMenu white-text"} id="mobile-button"><LuMenu /></button>
              </>}

              <AnimatePresence>
                {open && (
                  <motion.div
                    className="mobileMenu-container-rework"
                    id="mobile-container"
                    key="mobile-menu"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    
                  <motion.div
                    id="mobile-container"
                    key="mobile-menu"
                    initial={{ opacity: 0, x: 0, width: "0%" }}
                    animate={{ opacity: 1, x: 0, width: "90%" }}
                    exit={{ opacity: 0, x: 0, width: "0%" }}
                    transition={{ duration: 0.3 }}
                  >
                    <img src={logo1} alt="Nukeproof logo" id="mobile-logo" />
                    <NavLink to="/" onClick={() => setOpen(false)}><FaHome /> {homeText}</NavLink>
                    <NavLink className="pointer" onClick={() => setBikesOpenMobile(!bikesOpenMobile)}><MdPedalBike /> {bikesText} {!bikesOpenMobile ? <RiArrowDropDownLine className="dropdown-icon" /> : <RiArrowDropUpLine className="dropdown-icon" />}</NavLink>
                    {bikesOpenMobile && (
                      <>
                        {categories.length > 0 ? (
                          categories.map((bike, index) => (
                            <NavLink
                              key={index}
                              to={`/kola/${bike.cesta}`}
                              onClick={() => {
                                setBikesOpenMobile(false);
                                setOpen(false);
                              }}
                              className="mobile-submenu-item"
                            >
                              <TbCornerDownRight /> {bike.nazev}
                            </NavLink>
                          ))
                        ) : null}
                      </>
                    )}
                    <NavLink to="/o-nukeproof" className="pointer" onClick={() => setOpen(false)}><Nukeproof /> {aboutText}</NavLink>
                    <NavLink to="/prodejci" className="pointer" onClick={() => setOpen(false)}><FaStore /> {dealersText}</NavLink>
                    <NavLink className="pointer" to="/konfigurator" onClick={() => setOpen(false)}><FaCogs /> <label className="konfigurator-topbar">{configuratorText}</label></NavLink>
                    <span />
                    </motion.div>
                  </motion.div> 
                )}
              </AnimatePresence>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default App;
